/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent } from 'mbs-ui-kit';
import { PermissionsEnum } from 'mbs-ui-shared@models';

@Component({
  selector: 'mbs-recovery-code',
  templateUrl: './recovery-code.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonComponent, FormsModule, ReactiveFormsModule, I18NextPipe, CanPipe]
})
export class RecoveryCodeComponent {
  protected readonly PermissionsEnum = PermissionsEnum;
  private clipboard = inject(Clipboard);
  private i18 = inject(I18NextPipe);
  private datePipe = inject(DatePipe);

  @Input() isLogin = false;
  @Input() isResetCodes = false;
  @Input() codes;
  @Input() authId: string;

  public codesGeneratedDate = this.i18.transform('shared:tfa.recoveryCode.generationCodesDate', {
    date: this.datePipe.transform(new Date(), 'medium')
  });

  copy() {
    this.clipboard.copy([this.codesGeneratedDate, ...this.codes].join('\r\n'));
  }

  save() {
    const element = document.createElement('a');
    element.setAttribute(
      'href',
      'data:text/plain;charset=utf-8,%EF%BB%BF' + encodeURIComponent([this.codesGeneratedDate, ...this.codes].join('\r\n'))
    );
    element.setAttribute('download', 'codes.txt');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  print() {
    const windowInstance = window.open('', 'PRINT', 'height=400,width=600');

    const elements = this.codes?.reduce((acc, el) => {
      return acc + `<div>${el}</div>`;
    }, '');

    windowInstance.document.write(`
      ${this.codesGeneratedDate}
      ${elements}
    `);

    windowInstance.document.close();
    windowInstance.focus();
    windowInstance.print();
    windowInstance.close();
  }
}
